package or.garden.manager

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.localStorage
import or.garden.manager.common.GardenHandler
import or.garden.manager.components.SnackbarHost
import or.garden.manager.components.SnackbarMessage
import or.garden.manager.domain.GardenHttpClient
import or.garden.manager.features.Dashboard
import or.garden.manager.features.auth.LoginScreen
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.TagElement
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.renderComposable

fun main() {
    GardenHttpClient.token = localStorage.getItem(GardenHandler.JWT) ?: ""
    GardenHttpClient.refreshToken = localStorage.getItem(GardenHandler.REFRESH_JWT) ?: ""

    renderComposable(rootElementId = "app-container") {
        var isLoggedIn by remember { mutableStateOf(GardenHttpClient.token.isNotBlank()) }
        var snackbarMessage by remember { mutableStateOf<SnackbarMessage?>(null) }

        // Injecting Shimmer Styles and Snackbar Animation
        TagElement<org.w3c.dom.HTMLStyleElement>(
            tagName = "style",
            applyAttrs = { },
            content = {
                Text(
                    """
                    @keyframes shimmer-animation { 0% { background-position: -1000px 0; } 100% { background-position: 1000px 0; } }
                    @keyframes snackbar-in { 0% { transform: translateY(100%); opacity: 0; } 100% { transform: translateY(0); opacity: 1; } }
                    .shimmer-effect {
                        background: linear-gradient(to right, #f6f7f8 8%, #edeef1 18%, #f6f7f8 33%);
                        background-size: 1000px 100%;
                        animation: shimmer-animation 2s linear infinite forwards;
                    }
                """.trimIndent()
                )
            }
        )

        Div({
            style {
                property("min-height", "100vh")
                property("display", "flex")
                property("flex-direction", "column")
            }
        }) {
            if (isLoggedIn) {
                Dashboard {
                    localStorage.removeItem(GardenHandler.JWT)
                    localStorage.removeItem(GardenHandler.REFRESH_JWT)
                    isLoggedIn = false
                }
            } else {
                LoginScreen(
                    onLoginSuccess = {
                        isLoggedIn = true
                    },
                    showSnackbar = { msg, type ->
                        snackbarMessage = SnackbarMessage(msg, type)
                    }
                )
            }
        }

        // SnackbarHost mora biti izvan glavnog layout-a ali unutar renderComposable
        SnackbarHost(snackbarMessage) {
            snackbarMessage = null
        }

        GardenHttpClient.unauthorizeHandler = {
            localStorage.removeItem(GardenHandler.JWT)
            localStorage.removeItem(GardenHandler.REFRESH_JWT)
            isLoggedIn = false
        }
    }
}
